import globals from '../../../components/common/globals';
import vxMysteryHeader from '../vx-mystery-header/vx-mystery-header.vue';
import vxMysteryFooter from '../vx-mystery-footer/vx-mystery-footer.vue';
import vxMysteryReferralThankYouMixin from './vx-mystery-referral-thank-you-mixin';
import vxModal from '../../../components/common/vx-modal/vx-modal.vue';

export default {
  name: 'vx-mystery-referral-thank-you',
  components: { vxMysteryHeader, vxMysteryFooter, vxModal },
  data() {
    return {
      globals,
      mysCpuserId: '',
      qplesCouponId: '',
      qplesUniqueId: '',
      mysEmailId: '',
    };
  },
  mixins: [vxMysteryReferralThankYouMixin],
  mounted() {
    if (!this.globals.getCookie('mys_cpuserid')) {
      window.location.href = '/mystery-coupon/opt-in';
    } else {
      this.mysCpuserId = this.globals.getCookie('mys_cpuserid');
    }

    if (!this.globals.getCookie('mys_qples_couponids') || !this.globals.getCookie('mys_qples_uniqueid')) {
      this.qplesErrorMsg();
    } else {
      if (this.globals.getCookie('mys_qples_couponids')) { this.qplesCouponId = this.globals.getCookie('mys_qples_couponids'); }
      if (this.globals.getCookie('mys_qples_uniqueid')) { this.qplesUniqueId = this.globals.getCookie('mys_qples_uniqueid'); }
    }

    if (this.globals.getCookie('mys_email')) {
      this.mysEmailId = this.globals.getCookie('mys_email');
    }
  },
  methods: {
    qplesErrorMsg() {
      this.$refs.viewQplesErrModal.open();
    },
    showCoupon() {
      this.globals.clearAllCookies();
      window.location.href = `https://mutde2xgea.execute-api.us-east-1.amazonaws.com/production/qube/load?uniqueID=${this.qplesUniqueId}&couponIDs=${this.qplesCouponId}&protocol=https&domainName=coupon.qpleshq.com&extToken=${this.mysCpuserId}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/marketingpages/components/vx-mystery-referral-thank-you/vx-mystery-referral-thank-you.js